import { CommentType } from "./comment-type.constat";

export class Comment {
  commenterId: string;
  resolvedInd: boolean;
  replies: Comment[];
  referenceId: string;

  constructor(
    public id: string,
    public sourceReferenceId: string,
    public commentDateTime: Date,
    public commenterName: string,
    public commentType: CommentType,
    public commentText: string = '',
    public replyToCommentId: string = ''
  ) {}
}
